import { atLeastOne, concatFailure, fromParent, items, required, shape, unique, when } from '@totalsoft/pure-validations';

export const generalDataValidator = shape({ name: required });

export const detailsValidator = concatFailure(
  unique(x => x.orderNo || {}, 'GenericFilterTemplate.Validators.OrderNoUnique'),
  items(
    shape({
      orderNo: required,
      paramId: required,
      operatorId: required,
      filterValue: fromParent(parent => when(parent.paramIsList === false || parent.operatorIsMultipleSelection === false)(required)),
      filterValues: fromParent(parent =>
        when(parent.paramIsList === true && parent.operatorIsMultipleSelection === true)(concatFailure([atLeastOne, items(required)]))
      )
    })
  )
);
